/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import countries from "countries-list";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { updateUser } from "../../../../redux/auth/authSlice";
import { OTPModalUI } from "./OTPModalUI";
import { CiCircleCheck } from "react-icons/ci";
import InfoIcon from '@mui/icons-material/Info';
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";
import OtpVerification from "views/dashboard/Update-pending-verification/OtpVerification";

const PersonalInformation = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [tooltipError, setTooltipError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [personalData, setPersonalData] = useState({});
  const [isEmailSent, setIsEmailSent] = useState({
    isOldEmailVerified: false,
    isNewEmailVerified: false,
  });
  const inputRefs = useRef([]);
  const [OTPModal, setOTPModal] = useState(0);
  const [OTPField, setOTPField] = useState(new Array(4).fill(""));
  const [counter, setCounter] = useState(300);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [uploadedLogo, setUploadedLogo] = useState(null);
  const [isDefaultLogo, setIsDefaultLogo] = useState(false);
  const fileInputRef = useRef(null);
  const [hasChanges, setHasChanges] = useState(false);
  const [originalData, setOriginalData] = useState({});

  const [occupation, setOccupation] = useState([
    {
      occupationId: 1,
      name: "Select Your Occupation",
      createdBy: 1,
      createdDate: "2022-12-05T13:17:29.3286288",
      updatedBy: 1,
      updatedDate: "2022-12-05T13:17:27.1844533",
      isDelete: false,
    },
  ]);

  const user = useSelector((state) => state.auth.user);
  const language = localStorage.getItem("i18nextLng");
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const {
    watch,
    reset,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const emailValue = watch("email");
  const formData = watch(); 

  // Check for changes in form data or logo
  useEffect(() => {
    if (originalData && Object.keys(originalData).length > 0) {
      const currentData = getValues();
      const hasFormChanges = Object.keys(originalData).some(key => {
        return originalData[key] !== currentData[key];
      });
      const hasLogoChanges = selectedLogo !== null;
      setHasChanges(hasFormChanges || hasLogoChanges);
    }
  }, [formData, selectedLogo, originalData, getValues]);

  useEffect(() => {
    sessionStorage.setItem(`redirect${user?.userId}AgainToPersonalInfo`, false);
    if (searchParams.get("showModal")) {
      setShowModal(true);
    }
    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
   const closeModal = () => setIsModalOpen(false);
   const openModal = () => setIsModalOpen(true);
  useEffect(() => {
    const fetchPersonalInfo = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`/employee/get/${user?.userId}`);
        const responseData = {
          firstName: res.data.response.firstName,
          lastName: res.data.response.lastName,
          email: res.data.response.email,
          address: res.data.response.address,
          zipCode: res.data.response.zipCode,
          city: res.data.response.city,
          organisation: res.data.response.organisation,
          country: res.data.response.country,
          phoneNo: res.data.response.phoneNo,
          ssn: res.data.response.ssn,
          dateOfBirth: res.data.response.dateOfBirth,
          profession: res.data.response.profession,
          customCheck: res.data.response.customCheck,
          accountType: res.data.response?.accountType,
        };
        reset(responseData);
        setOriginalData(responseData);
        setPersonalData(res.data.response);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchPersonalInfo();
    fetchOccupation();
    fetchUploadedLogo(); 
  }, [user?.userId, reset]);

  const fetchOccupation = async () => {
    try {
      const res = await axios.get(`/settings/get-all-occupation-data`);
      setOccupation(res.data?.response);
    } catch (err) {}
  };

  const [toggle, setToggle] = useState(false);
  const [deleteLogoModal, setDeleteLogoModal] = useState(false);

  const onSubmit = async (values) => {
    setToggle(false);
    try {
      setLoading(true);
      const newObj = {
        ...values,
        id: user?.userId,
        ssn: values.ssn ? values.ssn : "",
        lastName: values.lastName,
        dateOfBirth: values.dateOfBirth ? values.dateOfBirth : "",
      };
      const result = await axios.put("/employee/update", newObj);
      if (result?.status === 200) {
        let logoUploadSuccess = true;
        
        // Upload logo if one is selected
        if (selectedLogo) {
          try {
            const formData = new FormData();
            const logoFormat = selectedLogo?.name?.split(".")?.pop();
            if (!selectedLogo?.type?.startsWith("image/") || !(logoFormat === "png" || logoFormat === "jpg")) {
              toast.error(t("Logo format not supported, only jpg or png are allowed"));
              return;
            }

            formData.append("file", selectedLogo);

            const logoResult = await axios.post('signup/invoice-logo', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });

             if (logoResult?.status === 200) {
              try {
                const logoResponse = await axios.get(`/signup/invoice-logo-stream?userId=${user?.userId}`, {
                  responseType: 'blob'
                });
                if (logoResponse?.status === 200 && logoResponse.data.size > 0) {
                  const logoUrl = URL.createObjectURL(logoResponse.data);
                  setUploadedLogo(logoUrl);
                  setIsDefaultLogo(false);
                }
              } catch (logoError) {
                setUploadedLogo('/assets/logo_large.png');
                setIsDefaultLogo(true);
                console.error("Error fetching uploaded logo:", logoError);
              }
              
              setSelectedLogo(null);
              setLogoPreview(null);
              if (fileInputRef.current) {
                fileInputRef.current.value = '';
              }
            } else {
              logoUploadSuccess = false;
            }
          } catch (logoError) {
            console.error("Logo upload failed:", logoError);
            logoUploadSuccess = false;
          }
        }
        
        const updatedData = { ...originalData, ...values };
        setOriginalData(updatedData);
        setHasChanges(false);
        
        fetchOccupation();
        
        if (logoUploadSuccess) {
          toast.success(t("Your personal information has been updated successfully"));
        } else if (selectedLogo) {
          toast.warn(t("Personal information updated, but logo upload failed. Please try uploading the logo again."));
        } else {
          toast.success(t("Your personal information has been updated successfully"));
        }
        
        const userObj = {
          ...user,
          ...values,
        };

        dispatch(updateUser(userObj));
      } else {
        toast.error(t("Something went wrong please try again."));
      }
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
    } finally {
      setLoading(false);
    }  };

  const handleCancel = () => {
    // Reset form to original data
    reset(originalData);
    // Clear any selected logo
    setSelectedLogo(null);
    setLogoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    // Reset change tracking
    setHasChanges(false);
    toast.info(t("Changes have been discarded"));
  };

  const handleChange = (event) => {
    if (!event.nativeEvent.inputType) {
      event.target.blur();
    }
  };

  const clear = (event) => {
    event.target.value = "";
  };

  const newDetails = [];
  Object.keys(countries.countries).forEach((code) => {
    // if (countries.countries[code].continent === "EU") {
    newDetails.push(countries.countries[code].name);
    // }
  });
  newDetails.splice(45, 1);

  useEffect(() => {
    setTimeout(() => {
      setTooltipError(false);
    }, 4000);
  }, [tooltipError]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleClose = () => setToggle(false);

  const handleShow = () => {
    setToggle(true);
  };

  const handleDeleteLogoClose = () => setDeleteLogoModal(false);
  const handleDeleteLogoShow = () => {
    setDeleteLogoModal(true);
  };

  const { accountType } = getValues();

  const verifyEmail = async (type) => {
    setLoading(true);
    try {
      const URL = "/settings/generate-otp";
      let body;
      if (type === 1) {
        body = {
          type: 1,
          email: "",
          lang: language,
        };
      }
      if (type === 2) {
        body = {
          type: 2,
          email: emailValue,
          lang: language,
        };
      }
      const result = await axios.post(URL, body);
      if (result?.status === 200) {
        setLoading(false);
        toast.success(t("Email has been successfully sent to your new email"));
        if (type === 1) {
          setOTPModal(1);
          setCounter(300);
        }
        if (type === 2) {
          setOTPModal(2);
          setCounter(300);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(t(error?.response?.data?.message));
    }
  };

  const handleChangeOTP = async (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...OTPField];

    newOtp[index] = value.substring(value.length - 1);
    setOTPField(newOtp);

    if (value && index < 4 - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
    if (value && index === 3) {
      const combinedOTP = newOtp.join("");

      if (OTPModal === 1) {
        setLoading(true);
        try {
          const URL = `/employee/verify-old?code=${Number(combinedOTP)}`;
          const result = await axios.put(URL);
          if (result?.status === 200) {
            setLoading(false);
            toast.success(t("Your old email has been verified successfully"));
            setIsEmailSent((prev) => ({
              ...prev,
              isOldEmailVerified: true
            }));
            setOTPModal(0);
            setOTPField(new Array(4).fill(""));
          } else {
            setLoading(false);
            toast.error(t("Old email verification failed. Please try again."));
            return;
          }
        } catch (err) {setLoading(false);
          toast.error(t(err?.response?.data?.message)); setOTPModal(1);
          return;
        }
      }
      if (OTPModal === 2) {
        if (!isEmailSent.isOldEmailVerified) {
          toast.error(t("Please verify your old email first."));
          return;
        }
        setLoading(true);
        try {
          const URL = `/employee/verify-new?code=${Number(
            combinedOTP
          )}&email=${emailValue}`;
          const result = await axios.put(URL);
          if (result?.status === 200) {
            setLoading(false);
            toast.success(t("Your new email has been verified successfully"));
            setIsEmailSent({
              isNewEmailVerified: true,
              isOldEmailVerified: true
            });
            setOTPModal(0);
            setOTPField(new Array(4).fill(""));
          } else {
            setLoading(false);
            toast.error(t("New email verification failed. Please try again."));
          }
        } catch (err) {
          setLoading(false);
          toast.error(t(err?.response?.data?.message));
        }
      }
    }
  };

  const resendOTP = async () => {
    setOTPField(new Array(4).fill(""));
    if (OTPModal === 1) {
      verifyEmail(1);
    } else {
      verifyEmail(2);
    }
  };

  const verifyBtnCss = {
    height: "38px",
    marginTop: "13px",
    width: "auto",
    position: "absolute",
    top: "19px",
    right: "0px",
    borderRadius: "0 5px 5px 0",
    fontSize: "14px",
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  const handleLogoSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error(t("Invalid file type. Only JPG or PNG files are allowed"));
        return;
      }

      if (file.size > 1024 * 1024) {
        toast.error(t("File too large. The maximum allowed size is 1 MB"));
        return;
      }

      setSelectedLogo(file);

      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const removeLogo = () => {
    setSelectedLogo(null);
    setLogoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const fetchUploadedLogo = async () => {
    try {
      const logoResponse = await axios.get(`/signup/invoice-logo-stream?userId=${user?.userId}`, {
        responseType: 'blob'
      });
      if (logoResponse?.status === 200 && logoResponse.data.size > 0) {
        const logoUrl = URL.createObjectURL(logoResponse.data);
        setUploadedLogo(logoUrl);
        setIsDefaultLogo(false);
      }
    } catch (error) {
      console.log("No uploaded logo found or error fetching logo");
      setUploadedLogo('/assets/logo_large.png');
      setIsDefaultLogo(true);
    }
  };
  
  const deleteUploadedLogo = async () => {
    setDeleteLogoModal(false);
    setLoading(true);
    try {
      const result = await axios.delete(`/signup/user-logo?userId=${user?.userId}`);
      
      if (result?.status === 200) {
        toast.success(t("Logo deleted successfully"));
        setUploadedLogo(null);
        setIsDefaultLogo(false);

        if (uploadedLogo) {
          URL.revokeObjectURL(uploadedLogo);
        }
        await fetchUploadedLogo();
      } else {
        toast.error(t("Failed to delete logo"));
      }
    } catch (error) {
      toast.error(t(error?.response?.data?.message || "Failed to delete logo"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content personalinformation-page mt-5 prsnl_responve">
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/settings/personal-information"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/installningar/personlig-information"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <Modal show={toggle} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Personal Information")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Are you sure you want to update personal information ?")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("No")}
          </Button>
          <Button
            variant="primary"
            className="theme_btn"
            onClick={handleSubmit(onSubmit)}
          >
            {t("Yes")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteLogoModal} onHide={handleDeleteLogoClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Logo")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Are you sure you want to delete the logo?")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary " onClick={handleDeleteLogoClose} style={{ borderRadius: "30px",padding: "12px 30px" }}>
            {t("Cancel")}
          </Button>
          <Button className="text-light save_add_customer new_theme_btn" onClick={deleteUploadedLogo} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t("Deleting...")}
              </>
            ) : (
              t("Delete")
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <div className="header">
          <h4 className="accident_ins font-weight-bold">
            {t("Personal data")}
          </h4>
          <span className="text-primary useriddiv">
            {t("User id")}: #{user?.userId ? user?.userId : "---"}
          </span>
          <span className="text-primary useriddiv">
            {t("Created Date")}:{" "}
            {personalData?.createdDate?.split("T")[0] || "---"}
          </span>
        </div>
        <p className="large-margin">
          <span>{t("pihere")}</span>
        </p>
      </div>

      <div className="settings form_back mt-2">
        <div className="personal-info">
          <form onSubmit={handleSubmit(handleShow)} className="col-sm-12 px-1">
            <div>
              <h3>
                <span htmlFor="inputEmail4">
                  {accountType && accountType === 1
                    ? t("Private Account")
                    : t("Business Account")}
                </span>
              </h3>
            </div>
            <div className="row m-auto">
              <div className="form-row d-block w-100">
                <div className={`form-group ${"input-wrapper"}`}>
                  <label htmlFor="inputEmail4">{t("firstName")}</label>
                  <input
                    type="text"
                    id="name"
                    className={`form-control ${
                      errors.firstName ? "is-invalid" : ""
                    }`}
                    {...register("firstName", {
                      required: "Enter the first name",
                    })}
                  />
                </div>

                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4"> {t("lastName")} </label>

                  <input
                    type="text"
                    className={`form-control ${
                      errors.lastName ? "is-invalid" : ""
                    }`}
                    id="surname"
                    {...register("lastName", {
                      required: user?.accountType === 1 || false,
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div
                  className="form-group input-wrapper email"
                  style={{ position: "relative" }}
                >
                  <label htmlFor="inputEmail4">{t("email")}</label>
                  <input
                    type="text"
                    id="email"
                    className="form-control"
                    {...register("email", {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: t("Invalid email address"),
                      },
                      required: true,
                    })}
                  />
                  <div>
                    {(isEmailSent?.isNewEmailVerified ||   personalData?.email === emailValue) && (
                     <button disabled>
                        <CiCircleCheck
                          color="#0C9865"
                          style={{
                            height: "35px",
                            marginTop: "16px",
                            width: "auto",
                            position: "absolute",
                            top: "19px",
                            right: "0px",
                            borderRadius: "0 5px 5px 0",
                          }}
                        />
                      </button>
                    )}
                    {(personalData?.isVerified === true && isEmailSent?.isOldEmailVerified === false &&  personalData?.email !== emailValue) && (
                    <Button
                        style={verifyBtnCss}
                        // disabled={
                        //   emailValue?.length === 0 ||
                        //   personalData?.email === emailValue
                        // }
                        onClick={() => verifyEmail(1)}
                      >
                        {t("Verify")}
                      </Button>)}

                     {personalData?.isVerified === false && (
                     <Button
                        style={verifyBtnCss}
                        onClick={openModal}
                      >
                        {t("Verify")}
                      </Button>)}
                  </div>
                </div>

                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4"> {t("address")} </label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.address ? "is-invalid" : ""
                    }`}
                    id="address"
                    {...register("address", {
                      required: "Address is must",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("zipCode")} </label>
                  <input
                    type="text"
                    id="postal-code"
                    className={`form-control ${
                      errors.zipCode ? "is-invalid" : ""
                    }`}
                    {...register("zipCode", { required: true })}
                  />
                </div>
                <div className="form-group input-wrapper ">
                  <label htmlFor="inputEmail4">{t("city")} </label>

                  <input
                    type="text"
                    id="city"
                    className={`form-control ${
                      errors.city ? "is-invalid" : ""
                    }`}
                    {...register("city", {
                      required: "Enter your city",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper styled-select">
                  <label htmlFor="inputEmail4">{t("country")}</label>
                  <select
                    className={`border-0 p-0 country ${
                      errors.country ? "is-invalid" : ""
                    }`}
                    {...register("country", { required: true })}
                  >
                    <option value="">{t("Select Country")}</option>
                    <option value={"Sweden"}>{"Sweden"}</option>
                    <option value={"USA"}>{"USA"}</option>
                    {newDetails.map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("phoneNo")}</label>
                  <input
                    type="number"
                    id="phoneNo"
                    className={`form-control form-control-lg mb-0 ${
                      errors.phoneNo ? "is-invalid" : ""
                    }`}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 17))
                    }
                    {...register("phoneNo", {
                      className: "bg-warning",
                      required: "Phone no is required",
                    })}
                  />
                </div>
              </div>

              <div className="form-row d-block w-100">
                <div className="form-group input-wrapper">
                  {personalData?.dateOfBirth === "" ? (
                    <>
                      <label htmlFor="inputEmail4">
                        {" "}
                        {personalData?.dateOfBirth === ""
                          ? t("ssn")
                          : t("Date Of Birth")}
                      </label>
                      <input
                        type="text"
                        id="social-security-number"
                        readOnly
                        className={`form-control mb-0 ${
                          errors.ssn ? "is-invalid" : ""
                        }`}
                        {...register("ssn", {
                          pattern: {
                            value: /^[0-9+-]+$/,
                          },
                        })}
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor="inputEmail4">
                        {" "}
                        {personalData?.dateOfBirth === ""
                          ? t("ssn")
                          : t("Date Of Birth")}
                      </label>
                      <input
                        type="text"
                        id="social-security-number"
                        readOnly
                        className={`form-control mb-0 ${
                          errors.dateOfBirth ? "is-invalid" : ""
                        }`}
                        {...register("dateOfBirth", {
                          pattern: {
                            value: /^[0-9+-]+$/,
                          },
                        })}
                      />
                    </>
                  )}
                </div>
                <div className="form-group input-wrapper">
                  <label htmlFor="inputEmail4">{t("profession")} </label>
                  <input
                    className={`w-100 styled-select select form-control mt-0 ${
                      errors.profession ? "is-invalid" : ""
                    }`}
                    placeholder={watch("profession")}
                    list="select"
                    name="select"
                    {...register("profession", { required: true })}
                    onChange={handleChange}
                    onClick={clear}
                    onFocus={clear}
                  />
                  <datalist id="select">
                    {occupation.map((Profession) => {
                      return (
                        <option key={Profession.occupationId}>
                          {Profession.name}
                        </option>
                      );
                    })}
                    </datalist>
               </div>
             </div>
            </div>
          </form>
        </div>
      </div>

<div  className="settings form_back mt-3 mb-3">
  <label htmlFor="logoUpload"><b>{t("Invoice Settings")}</b></label>

  <div className="form-group Personal-data-main-div">
    <label htmlFor="logoUpload">{t("Invoice Logo")}</label>

    <div className="row align-items-start g-3">
      <div className="col-sm-6 px-0  pb-0">
        <div className="logo-upload-container upload-logo-view w-sm-100 w-50 mt-5 ">
          {logoPreview ? (
            <div className="logo-preview-container " style={{ position: 'relative' }}>
              <img src={logoPreview} alt="Logo Preview"className="logo-preview "/>
              <button type="button" onClick={removeLogo} className="remove-logo-button">
                ×
              </button>
              <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                {selectedLogo?.name} ({(selectedLogo?.size / 1024).toFixed(1)} KB)
              </div>
            </div>                      
            ) : uploadedLogo ? (                        
              <div className="uploaded-logo-container" style={{ position: 'relative' }}>
              <img src={uploadedLogo} alt="Uploaded Logo" onClick={() => fileInputRef.current?.click()} className="logo-file-input"/> 
              {!isDefaultLogo && (
                <button
                  type="button"
                  onClick={handleDeleteLogoShow}
                  className="delete-logo-button">
                  ×
                </button>
              )}
            </div>
          ) : (
            <div
              className="text-center"
              style={{ cursor: "pointer" }}
              onClick={() => fileInputRef.current?.click()}
            >
              <div className="fs-1 text-secondary mb-2">📷</div>
              <strong>{t("Click to select logo")}</strong>
              <div className="small text-muted mt-1">
                {t("Recommended size: 160x50px, Max: 1MB")}
              </div>
            </div>
          )}

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleLogoSelect}
            className="d-none"
            id="logoUpload"
          />
        </div>
      </div>

      {/* Logo Requirements Section */}
      <div id="logo-upload-container" className="col-sm-6 px-0 ">
        <div className="p-3 bg-light border rounded small">
          <h6 className="mb-3   d-flex align-items-center gap-2" style={{
                        marginBottom: '12px', 
            color: '#495057', 
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'

          } }>
            <InfoIcon className="text-muted" />
            {t("Logo Requirements")}
          </h6>
          
          <div style={{ marginBottom: '10px' }}>
            <strong style={{ color: '#495057' }}>{t("File Format")}:</strong>
            <div style={{ color: '#6c757d', marginTop: '2px' }}>
              {t("Only JPG and PNG files are supported for the best compatibility.")}
            </div>
          </div>

          <div style={{ marginBottom: '10px' }}>
            <strong style={{ color: '#495057' }}>{t("File Size")}:</strong>
            <div style={{ color: '#6c757d', marginTop: '2px' }}>
              {t("Maximum file size is 1MB to ensure fast loading times.")}
            </div>
          </div>

          <div style={{ marginBottom: '10px' }}>
            <strong style={{ color: '#495057' }}>{t("Image Dimensions")}:</strong>
            <div style={{ color: '#6c757d', marginTop: '2px' }}>
              {t("Recommended size is 160x50 pixels for optimal display on invoices.")}
            </div>
          </div>

          <div>
            <strong style={{ color: '#495057' }}>{t("Background")}:</strong>
            <div style={{ color: '#6c757d', marginTop: '2px' }}>
              {t("Logo should not contain background for a professional appearance.")}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      <div className="button-wrapper" style={{ display: 'flex', gap: '15px', alignItems: 'center', marginTop: '20px' }}>
        {hasChanges && (
          <Button
            type="button"
            onClick={handleCancel}
            className="btn btn-secondary"
            style={{ borderRadius: "30px", padding: "12px 30px", backgroundColor: "#f9f9fc"}}
          >
            <span>{t("Cancel")}</span>
          </Button>
        )}
        <Button
          type="button"
          onClick={handleShow}
          className="text-light save_add_customer new_theme_btn"
          disabled={!hasChanges}
        >
          <span>{t("Save Settings")}</span>
        </Button>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Information before we can register you")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {t(
              "To use our platform, we need you to enter your personal information here"
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

      {isModalOpen && <OtpVerification onClose={closeModal} email={null} newEmail={emailValue} />}

      <OTPModalUI
        OTPModal={OTPModal}
        setOTPModal={setOTPModal}
        resendOTP={resendOTP}
        OTPField={OTPField}
        setOTPField={setOTPField}
        inputRefs={inputRefs}
        handleChangeOTP={handleChangeOTP}
        counter={counter}
        setCounter={setCounter}
        verifyEmail={verifyEmail}
        newEmail={emailValue}
      />
    </div>
  );
};

export default PersonalInformation;
